import type {
  AnswerDetailResponse,
  AnswerResponse,
  ListAnswerWithCursorResponse,
} from '@coorum-research/shared-common/api-response'
import type {
  CreateAnswerValues,
  GetUniqueAnswerQuery,
  SearchTagAnswerListWithCursorQuery,
  UpdateAnswerValues,
} from '@coorum-research/shared-common/types/answer.type'
import http from './http'

export function answerApi() {
  const updateAnswer = async (id: string, data: UpdateAnswerValues): Promise<AnswerResponse> => {
    const response = await http.put(`/answers/${id}`, data)
    return response.data
  }

  const createAnswer = async (data: CreateAnswerValues): Promise<AnswerResponse> => {
    const response = await http.post(`/answers`, data)
    return response.data
  }

  const listAnswer = async (query: SearchTagAnswerListWithCursorQuery) => {
    const response = await http.get<ListAnswerWithCursorResponse>(`/answers`, {
      params: query,
      paramsSerializer: { indexes: null },
    })
    return response.data
  }

  const getAnswer = async (query: GetUniqueAnswerQuery): Promise<AnswerResponse | null> => {
    const response = await http.get(`/answer`, { params: query })
    return response.data
  }

  const getAnswerDetail = async (id: string): Promise<AnswerDetailResponse | null> => {
    const response = await http.get(`/answers/${id}`)
    return response.data
  }

  return {
    updateAnswer,
    createAnswer,
    listAnswer,
    getAnswer,
    getAnswerDetail,
  }
}
